import React from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Location from '../components/locations/Location';
import ViewLocations from '../components/locations/ViewLocations';
import NavBar from '../components/NavBar';
import { useParams } from 'react-router-dom';
const LocationsView = () => {
    const locationId = useParams();
    
    return (
        
        <div>
            <Header />
            <NavBar />
            <Location locationIdToEdit={locationId}/>
            <ViewLocations limit={3} />
            <Footer />
        </div>
    )
}

export default LocationsView
